import { render, staticRenderFns } from "./SpecialPizza.vue?vue&type=template&id=26b3c01b&scoped=true&"
import script from "./SpecialPizza.vue?vue&type=script&lang=js&"
export * from "./SpecialPizza.vue?vue&type=script&lang=js&"
import style0 from "./SpecialPizza.vue?vue&type=style&index=0&id=26b3c01b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b3c01b",
  null
  
)

export default component.exports